/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FC } from 'react';
import { ContentResponse, LikedResponse } from '../../../../../types/FormTypes';
import styles from './ResponseCard.module.css';
import Markdown from 'markdown-to-jsx';

const CustomH1: React.FC<{ children: string }> = ({ children, ...props }) => (
  <b {...props}>#{children}</b>
);

const ChatMessage: React.FC<{ text: string; sender: string }> = ({
  text,
  sender,
}) => {
  // Replace "\n" with actual new lines for markdown to handle it
  const formattedText = text.replace(/\\n/g, '\n');

  return (
    <div
      style={{
        marginBottom: '10px',
        padding: '10px',
        borderRadius: '5px',
        backgroundColor: sender === 'user' ? '#e0f7fa' : '#f1f8e9',
        alignSelf: sender === 'user' ? 'flex-start' : 'flex-end',
        maxWidth: '60%',
      }}
    >
      <strong>{sender === 'user' ? 'User' : 'Assistant'}:</strong>
      <Markdown
        options={{
          overrides: {
            h1: {
              component: CustomH1,
            },
          },
        }}
      >
        {formattedText}
      </Markdown>
    </div>
  );
};

const CustomMarkdown: React.FC<{ children: string }> = ({ children }) => {
  // Check if the content is a conversation format
  const tryParseConversation = (content: string) => {
    try {
      const jsonContent = JSON.parse(content);
      if (
        Array.isArray(jsonContent) &&
        jsonContent.every((item) => item.sender && item.text)
      ) {
        return jsonContent;
      }
    } catch (e) {
      return null;
    }
    return null;
  };

  const conversation = tryParseConversation(children);

  if (conversation) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {conversation.map((message, index) => (
          <ChatMessage
            key={index}
            text={message.text}
            sender={message.sender}
          />
        ))}
      </div>
    );
  }

  // If it's not a conversation, render as markdown
  return (
    <Markdown
      options={{
        overrides: {
          h1: {
            component: CustomH1,
          },
        },
      }}
    >
      {children}
    </Markdown>
  );
};

export const ResponseCard: FC<ContentResponse> = ({ id, response }) => {
  return (
    <div id={id} className={styles['container']}>
      <CustomMarkdown>{response.trim()}</CustomMarkdown>
    </div>
  );
};
